// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;The Lord tries the righteous as well as the wicked,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;but those who delight in violence his soul abhors.<br> </p> </div></div>";
// Exports
module.exports = code;